import { render, staticRenderFns } from "./iconfont.vue?vue&type=template&id=cbffc9ec&scoped=true&"
import script from "./iconfont.vue?vue&type=script&lang=js&"
export * from "./iconfont.vue?vue&type=script&lang=js&"
import style0 from "./iconfont.vue?vue&type=style&index=0&id=cbffc9ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbffc9ec",
  null
  
)

export default component.exports